export interface CommonConfig {
  baseUrlCDN: string;
  graphqlBaseUrl: string;
  staticBaseUrl: string;
  consumerUrl: string;
  ampUrl: string;
  canvasUrl: string;
  tokenlessAuthBaseUrl: string;
  securePaymentUrlV3BaseUrl: string;
  securePaymentUrlV2BaseUrl: string;
  termsAndConditionsFallbackUrl: string;
  threeDSRedirectionUrl: string;
  ecommerceThreeDSRedirectionUrl: string;
  optimizelyApiKey?: string;
  realTimeBiddingPollingInterval: number;
  pointsSSOGatewayUrl: string;
}

// common config for all
const commonConfig: CommonConfig = {
  baseUrlCDN: 'https://upgrade-cdn.plusgrade.com/offer',
  graphqlBaseUrl: globalThis.plusgrade?.graphqlUrl ?? 'https://service-hub-consumer.plusgrade.com/graphql',
  staticBaseUrl: globalThis.plusgrade?.staticUrl ?? 'https://static.plusgrade.com',
  consumerUrl: globalThis.plusgrade?.consumerUrl ?? 'https://upgrade.plusgrade.com',
  ampUrl: globalThis.plusgrade?.ampUrl ?? 'https://upg.plusgrade.com',
  canvasUrl: globalThis.plusgrade?.canvasUrl ?? 'https://canvas.plusgrade.com',
  tokenlessAuthBaseUrl:
    globalThis.plusgrade?.tokenlessAuthUrl ?? 'https://consumer.plusgrade.com/payment/eCommerceAuth',
  securePaymentUrlV3BaseUrl:
    globalThis.plusgrade?.securePaymentUrlV3Url ?? 'https://consumer.plusgrade.com/payment/v3/tokenize',
  securePaymentUrlV2BaseUrl:
    globalThis.plusgrade?.securePaymentUrlV2Url ?? 'https://consumer.plusgrade.com/payment/v2/securePaymentProfile',
  termsAndConditionsFallbackUrl:
    globalThis.plusgrade?.termsAndConditionsFallbackUrl ?? 'https://www.plusgrade.com/terms-and-conditions',
  threeDSRedirectionUrl:
    globalThis.plusgrade?.threeDSRedirectionUrl ?? 'https://consumer.plusgrade.com/payment/initiateChallenge',
  ecommerceThreeDSRedirectionUrl:
    globalThis.plusgrade?.ecommerceThreeDSRedirectionUrl ??
    'https://consumer.plusgrade.com/payment/eCommerce/3dsRedirect',
  pointsSSOGatewayUrl:
    globalThis.plusgrade?.pointsSSOGatewayUrl ?? 'https://ssogateway.points.com/SSOGateway/gateway.do',
  optimizelyApiKey: globalThis.plusgrade?.optimizelyApiKey,
  realTimeBiddingPollingInterval: 10000,
};

export default commonConfig;
